import React from 'react';
import { useLocation } from 'react-router-dom';
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import NotificationDropdown from '../NotificationDropdown';
import ProfileDropdown from '../ProfileDropdown';

const SECTION_TITLES = {
    dashboard: 'Dashboard',
    projects: 'Projects',
    tasks: 'Tasks',
    calendar: 'Calendar',
    meetings: 'Meetings',
    tickets: 'Tickets',
    reports: 'Reports',
    users: 'Users',
    excom: 'Executive Committee',
    governance: 'ICT Governance Hub',
    profile: 'Profile',
    notifications: 'Notifications',
};

const Topbar = ({ onToggleSidebar, sidebarCollapsed }) => {
    const { pathname } = useLocation();
    const section = pathname.split('/').filter(Boolean)[0];
    const title = SECTION_TITLES[section] || 'MyBank ICT';
    const ToggleIcon = sidebarCollapsed ? PanelLeftOpen : PanelLeftClose;

    return (
        <header
            className="app-topbar sticky top-0 z-topbar flex items-center gap-2"
            style={{
                height: 'var(--topbar-h)',
                backgroundColor: 'var(--bg-topbar)',
                borderBottom: '1px solid var(--border-color)',
                padding: '0 var(--page-pad-x)',
            }}
        >
            <button
                type="button"
                onClick={onToggleSidebar}
                aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                className="-ml-1.5 p-2 rounded-md text-ink-500 hover:bg-ink-100 hover:text-ink-800 transition-colors duration-150"
            >
                <ToggleIcon size={18} aria-hidden="true" />
            </button>

            <span className="hidden md:block text-md font-semibold text-ink-800 truncate">{title}</span>

            <div className="ml-auto flex items-center gap-1">
                <span className="hidden lg:block text-label text-ink-500 tabular mr-2">
                    {new Date().toLocaleDateString(undefined, {
                        weekday: 'short',
                        day: 'numeric',
                        month: 'short',
                        year: 'numeric',
                    })}
                </span>

                <NotificationDropdown />

                <span className="w-px h-5 bg-[var(--border-color)] mx-1.5" aria-hidden="true" />

                <ProfileDropdown />
            </div>
        </header>
    );
};

export default Topbar;
